export default "__VITE_ASSET__Rw2uziHz__"